/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../utils/request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
	TRequestData,
	TRequestConfig extends RequestConfig,
	TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
	? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
	: (
			requestData: TRequestData,
			...args: RequestFunctionRestArgs<typeof request>
	  ) => TRequestResult) & {
	requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.212.232.139:3000/mock/155' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = '' as any;
const dataKey_0_0_0_0 = 'data' as any;

/**
 * 接口 [租户设置↗](http://10.212.232.139:3000/project/155/interface/api/8435) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/tenant/set`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiTenantSetPostRequest {
	/**
	 * 租户key
	 */
	tenantKey?: string;
}

/**
 * 接口 [租户设置↗](http://10.212.232.139:3000/project/155/interface/api/8435) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/tenant/set`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiTenantSetPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [租户设置↗](http://10.212.232.139:3000/project/155/interface/api/8435) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/tenant/set`
 * @更新时间 `2023-06-21 14:48:06`
 */
type ApiTenantSetPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/tenant/set',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [租户设置↗](http://10.212.232.139:3000/project/155/interface/api/8435) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/tenant/set`
 * @更新时间 `2023-06-21 14:48:06`
 */
const apiTenantSetPostRequestConfig: ApiTenantSetPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/tenant/set',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: false,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiTenantSetPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [租户设置↗](http://10.212.232.139:3000/project/155/interface/api/8435) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/tenant/set`
 * @更新时间 `2023-06-21 14:48:06`
 */
export const apiTenantSetPost = /*#__PURE__*/ (
	requestData: ApiTenantSetPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiTenantSetPostResponse>(
		prepare(apiTenantSetPostRequestConfig, requestData),
		...args
	);
};

apiTenantSetPost.requestConfig = apiTenantSetPostRequestConfig;

/**
 * 接口 [以后设置↗](http://10.212.232.139:3000/project/155/interface/api/8441) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/set_later`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiSetLaterPostRequest {}

/**
 * 接口 [以后设置↗](http://10.212.232.139:3000/project/155/interface/api/8441) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/set_later`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiSetLaterPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [以后设置↗](http://10.212.232.139:3000/project/155/interface/api/8441) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/set_later`
 * @更新时间 `2023-06-21 14:48:06`
 */
type ApiSetLaterPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/set_later',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [以后设置↗](http://10.212.232.139:3000/project/155/interface/api/8441) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/set_later`
 * @更新时间 `2023-06-21 14:48:06`
 */
const apiSetLaterPostRequestConfig: ApiSetLaterPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/set_later',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: true,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiSetLaterPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [以后设置↗](http://10.212.232.139:3000/project/155/interface/api/8441) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/set_later`
 * @更新时间 `2023-06-21 14:48:06`
 */
export const apiSetLaterPost = /*#__PURE__*/ (
	requestData?: ApiSetLaterPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiSetLaterPostResponse>(
		prepare(apiSetLaterPostRequestConfig, requestData),
		...args
	);
};

apiSetLaterPost.requestConfig = apiSetLaterPostRequestConfig;

/**
 * 接口 [找回密码用户确认↗](http://10.212.232.139:3000/project/155/interface/api/8447) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/recover_password/user_confirm`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiRecoverPasswordUserConfirmPostRequest {
	/**
	 * 用户确认操作，0：不是我，1：是我
	 */
	confirmStatus?: number;
}

/**
 * 接口 [找回密码用户确认↗](http://10.212.232.139:3000/project/155/interface/api/8447) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/recover_password/user_confirm`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiRecoverPasswordUserConfirmPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [找回密码用户确认↗](http://10.212.232.139:3000/project/155/interface/api/8447) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/recover_password/user_confirm`
 * @更新时间 `2023-06-21 14:48:07`
 */
type ApiRecoverPasswordUserConfirmPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/recover_password/user_confirm',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [找回密码用户确认↗](http://10.212.232.139:3000/project/155/interface/api/8447) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/recover_password/user_confirm`
 * @更新时间 `2023-06-21 14:48:07`
 */
const apiRecoverPasswordUserConfirmPostRequestConfig: ApiRecoverPasswordUserConfirmPostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/recover_password/user_confirm',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: false,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiRecoverPasswordUserConfirmPost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [找回密码用户确认↗](http://10.212.232.139:3000/project/155/interface/api/8447) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/recover_password/user_confirm`
 * @更新时间 `2023-06-21 14:48:07`
 */
export const apiRecoverPasswordUserConfirmPost = /*#__PURE__*/ (
	requestData: ApiRecoverPasswordUserConfirmPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiRecoverPasswordUserConfirmPostResponse>(
		prepare(apiRecoverPasswordUserConfirmPostRequestConfig, requestData),
		...args
	);
};

apiRecoverPasswordUserConfirmPost.requestConfig = apiRecoverPasswordUserConfirmPostRequestConfig;

/**
 * 接口 [找回密码↗](http://10.212.232.139:3000/project/155/interface/api/8453) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/recover_password`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiRecoverPasswordPostRequest {}

/**
 * 接口 [找回密码↗](http://10.212.232.139:3000/project/155/interface/api/8453) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/recover_password`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiRecoverPasswordPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [找回密码↗](http://10.212.232.139:3000/project/155/interface/api/8453) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/recover_password`
 * @更新时间 `2023-06-21 14:48:07`
 */
type ApiRecoverPasswordPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/recover_password',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [找回密码↗](http://10.212.232.139:3000/project/155/interface/api/8453) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/recover_password`
 * @更新时间 `2023-06-21 14:48:07`
 */
const apiRecoverPasswordPostRequestConfig: ApiRecoverPasswordPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/recover_password',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: true,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiRecoverPasswordPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [找回密码↗](http://10.212.232.139:3000/project/155/interface/api/8453) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/recover_password`
 * @更新时间 `2023-06-21 14:48:07`
 */
export const apiRecoverPasswordPost = /*#__PURE__*/ (
	requestData?: ApiRecoverPasswordPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiRecoverPasswordPostResponse>(
		prepare(apiRecoverPasswordPostRequestConfig, requestData),
		...args
	);
};

apiRecoverPasswordPost.requestConfig = apiRecoverPasswordPostRequestConfig;

/**
 * 接口 [手机区号分页查询↗](http://10.212.232.139:3000/project/155/interface/api/8459) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/page_phone_codes`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiPagePhoneCodesPostRequest {
	/**
	 * 第几页，从1开始
	 */
	pageNum?: number;
	/**
	 * 每页大小
	 */
	pageSize?: number;
}

/**
 * 接口 [手机区号分页查询↗](http://10.212.232.139:3000/project/155/interface/api/8459) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/page_phone_codes`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiPagePhoneCodesPostResponse {
	/**
	 * 总数
	 */
	total?: number;
	/**
	 * 是否还有记录
	 */
	more?: boolean;
	/**
	 * 具体列表
	 */
	list?: {
		/**
		 * 地区名，根据语言信息匹配
		 */
		name?: string;
		/**
		 * 中文拼音前缀顺序
		 */
		pinyinSortPrefix?: string;
		/**
		 * 国家区域Code
		 */
		nationCode?: string;
		/**
		 * 电话区号
		 */
		phoneCode?: string;
	}[];
}

/**
 * 接口 [手机区号分页查询↗](http://10.212.232.139:3000/project/155/interface/api/8459) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/page_phone_codes`
 * @更新时间 `2023-06-21 14:48:07`
 */
type ApiPagePhoneCodesPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/page_phone_codes',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [手机区号分页查询↗](http://10.212.232.139:3000/project/155/interface/api/8459) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/page_phone_codes`
 * @更新时间 `2023-06-21 14:48:07`
 */
const apiPagePhoneCodesPostRequestConfig: ApiPagePhoneCodesPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/page_phone_codes',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: false,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiPagePhoneCodesPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [手机区号分页查询↗](http://10.212.232.139:3000/project/155/interface/api/8459) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/page_phone_codes`
 * @更新时间 `2023-06-21 14:48:07`
 */
export const apiPagePhoneCodesPost = /*#__PURE__*/ (
	requestData: ApiPagePhoneCodesPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiPagePhoneCodesPostResponse>(
		prepare(apiPagePhoneCodesPostRequestConfig, requestData),
		...args
	);
};

apiPagePhoneCodesPost.requestConfig = apiPagePhoneCodesPostRequestConfig;

/**
 * 接口 [Oscar Verify解绑定↗](http://10.212.232.139:3000/project/155/interface/api/8465) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/unbind`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiOscarVerifyUnbindPostRequest {}

/**
 * 接口 [Oscar Verify解绑定↗](http://10.212.232.139:3000/project/155/interface/api/8465) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/unbind`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiOscarVerifyUnbindPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [Oscar Verify解绑定↗](http://10.212.232.139:3000/project/155/interface/api/8465) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/unbind`
 * @更新时间 `2023-06-21 14:48:07`
 */
type ApiOscarVerifyUnbindPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/oscar_verify/unbind',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [Oscar Verify解绑定↗](http://10.212.232.139:3000/project/155/interface/api/8465) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/unbind`
 * @更新时间 `2023-06-21 14:48:07`
 */
const apiOscarVerifyUnbindPostRequestConfig: ApiOscarVerifyUnbindPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/oscar_verify/unbind',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: true,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiOscarVerifyUnbindPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [Oscar Verify解绑定↗](http://10.212.232.139:3000/project/155/interface/api/8465) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/unbind`
 * @更新时间 `2023-06-21 14:48:07`
 */
export const apiOscarVerifyUnbindPost = /*#__PURE__*/ (
	requestData?: ApiOscarVerifyUnbindPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiOscarVerifyUnbindPostResponse>(
		prepare(apiOscarVerifyUnbindPostRequestConfig, requestData),
		...args
	);
};

apiOscarVerifyUnbindPost.requestConfig = apiOscarVerifyUnbindPostRequestConfig;

/**
 * 接口 [不能扫描Oscar verify设备绑定二维码↗](http://10.212.232.139:3000/project/155/interface/api/8471) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/unable_to_scan_qrcode`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiOscarVerifyBindUnableToScanQrcodePostRequest {}

/**
 * 接口 [不能扫描Oscar verify设备绑定二维码↗](http://10.212.232.139:3000/project/155/interface/api/8471) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/unable_to_scan_qrcode`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiOscarVerifyBindUnableToScanQrcodePostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [不能扫描Oscar verify设备绑定二维码↗](http://10.212.232.139:3000/project/155/interface/api/8471) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/unable_to_scan_qrcode`
 * @更新时间 `2023-06-21 14:48:07`
 */
type ApiOscarVerifyBindUnableToScanQrcodePostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/oscar_verify/bind/unable_to_scan_qrcode',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [不能扫描Oscar verify设备绑定二维码↗](http://10.212.232.139:3000/project/155/interface/api/8471) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/unable_to_scan_qrcode`
 * @更新时间 `2023-06-21 14:48:07`
 */
const apiOscarVerifyBindUnableToScanQrcodePostRequestConfig: ApiOscarVerifyBindUnableToScanQrcodePostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/oscar_verify/bind/unable_to_scan_qrcode',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: true,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiOscarVerifyBindUnableToScanQrcodePost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [不能扫描Oscar verify设备绑定二维码↗](http://10.212.232.139:3000/project/155/interface/api/8471) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/unable_to_scan_qrcode`
 * @更新时间 `2023-06-21 14:48:07`
 */
export const apiOscarVerifyBindUnableToScanQrcodePost = /*#__PURE__*/ (
	requestData?: ApiOscarVerifyBindUnableToScanQrcodePostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiOscarVerifyBindUnableToScanQrcodePostResponse>(
		prepare(apiOscarVerifyBindUnableToScanQrcodePostRequestConfig, requestData),
		...args
	);
};

apiOscarVerifyBindUnableToScanQrcodePost.requestConfig =
	apiOscarVerifyBindUnableToScanQrcodePostRequestConfig;

/**
 * 接口 [发送Oscar verify设备绑定链接↗](http://10.212.232.139:3000/project/155/interface/api/8477) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/send_link`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiOscarVerifyBindSendLinkPostRequest {
	/**
	 * 绑定链接发送方式  [1-email , 2-phone ]
	 */
	type?: number;
	/**
	 * 发送目标，邮箱或手机号
	 */
	target?: string;
}

/**
 * 接口 [发送Oscar verify设备绑定链接↗](http://10.212.232.139:3000/project/155/interface/api/8477) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/send_link`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiOscarVerifyBindSendLinkPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [发送Oscar verify设备绑定链接↗](http://10.212.232.139:3000/project/155/interface/api/8477) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/send_link`
 * @更新时间 `2023-06-21 14:48:07`
 */
type ApiOscarVerifyBindSendLinkPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/oscar_verify/bind/send_link',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [发送Oscar verify设备绑定链接↗](http://10.212.232.139:3000/project/155/interface/api/8477) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/send_link`
 * @更新时间 `2023-06-21 14:48:07`
 */
const apiOscarVerifyBindSendLinkPostRequestConfig: ApiOscarVerifyBindSendLinkPostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/oscar_verify/bind/send_link',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: false,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiOscarVerifyBindSendLinkPost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [发送Oscar verify设备绑定链接↗](http://10.212.232.139:3000/project/155/interface/api/8477) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/send_link`
 * @更新时间 `2023-06-21 14:48:07`
 */
export const apiOscarVerifyBindSendLinkPost = /*#__PURE__*/ (
	requestData: ApiOscarVerifyBindSendLinkPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiOscarVerifyBindSendLinkPostResponse>(
		prepare(apiOscarVerifyBindSendLinkPostRequestConfig, requestData),
		...args
	);
};

apiOscarVerifyBindSendLinkPost.requestConfig = apiOscarVerifyBindSendLinkPostRequestConfig;

/**
 * 接口 [刷新Oscar Verify绑定二维码↗](http://10.212.232.139:3000/project/155/interface/api/8483) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/refresh_qrcode`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiOscarVerifyBindRefreshQrcodePostRequest {}

/**
 * 接口 [刷新Oscar Verify绑定二维码↗](http://10.212.232.139:3000/project/155/interface/api/8483) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/refresh_qrcode`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiOscarVerifyBindRefreshQrcodePostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [刷新Oscar Verify绑定二维码↗](http://10.212.232.139:3000/project/155/interface/api/8483) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/refresh_qrcode`
 * @更新时间 `2023-06-21 14:48:07`
 */
type ApiOscarVerifyBindRefreshQrcodePostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/oscar_verify/bind/refresh_qrcode',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [刷新Oscar Verify绑定二维码↗](http://10.212.232.139:3000/project/155/interface/api/8483) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/refresh_qrcode`
 * @更新时间 `2023-06-21 14:48:07`
 */
const apiOscarVerifyBindRefreshQrcodePostRequestConfig: ApiOscarVerifyBindRefreshQrcodePostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/oscar_verify/bind/refresh_qrcode',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: true,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiOscarVerifyBindRefreshQrcodePost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [刷新Oscar Verify绑定二维码↗](http://10.212.232.139:3000/project/155/interface/api/8483) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/bind/refresh_qrcode`
 * @更新时间 `2023-06-21 14:48:07`
 */
export const apiOscarVerifyBindRefreshQrcodePost = /*#__PURE__*/ (
	requestData?: ApiOscarVerifyBindRefreshQrcodePostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiOscarVerifyBindRefreshQrcodePostResponse>(
		prepare(apiOscarVerifyBindRefreshQrcodePostRequestConfig, requestData),
		...args
	);
};

apiOscarVerifyBindRefreshQrcodePost.requestConfig =
	apiOscarVerifyBindRefreshQrcodePostRequestConfig;

/**
 * 接口 [身份认证时自动向Oscar Verify发送推送确认通知接↗](http://10.212.232.139:3000/project/155/interface/api/8489) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/auto_send_push`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiOscarVerifyAutoSendPushPostRequest {
	/**
	 * 用户选择，0：不选择，1：选择
	 */
	option?: number;
}

/**
 * 接口 [身份认证时自动向Oscar Verify发送推送确认通知接↗](http://10.212.232.139:3000/project/155/interface/api/8489) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/auto_send_push`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiOscarVerifyAutoSendPushPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [身份认证时自动向Oscar Verify发送推送确认通知接↗](http://10.212.232.139:3000/project/155/interface/api/8489) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/auto_send_push`
 * @更新时间 `2023-06-21 14:48:07`
 */
type ApiOscarVerifyAutoSendPushPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/oscar_verify/auto_send_push',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [身份认证时自动向Oscar Verify发送推送确认通知接↗](http://10.212.232.139:3000/project/155/interface/api/8489) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/auto_send_push`
 * @更新时间 `2023-06-21 14:48:07`
 */
const apiOscarVerifyAutoSendPushPostRequestConfig: ApiOscarVerifyAutoSendPushPostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/oscar_verify/auto_send_push',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: false,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiOscarVerifyAutoSendPushPost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [身份认证时自动向Oscar Verify发送推送确认通知接↗](http://10.212.232.139:3000/project/155/interface/api/8489) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/oscar_verify/auto_send_push`
 * @更新时间 `2023-06-21 14:48:07`
 */
export const apiOscarVerifyAutoSendPushPost = /*#__PURE__*/ (
	requestData: ApiOscarVerifyAutoSendPushPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiOscarVerifyAutoSendPushPostResponse>(
		prepare(apiOscarVerifyAutoSendPushPostRequestConfig, requestData),
		...args
	);
};

apiOscarVerifyAutoSendPushPost.requestConfig = apiOscarVerifyAutoSendPushPostRequestConfig;

/**
 * 接口 [下一步↗](http://10.212.232.139:3000/project/155/interface/api/8495) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/next_step`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiNextStepPostRequest {
	/**
	 * 当前处理类型，合法值为（4,5）  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
	 */
	handlerType?: number;
}

/**
 * 接口 [下一步↗](http://10.212.232.139:3000/project/155/interface/api/8495) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/next_step`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiNextStepPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [下一步↗](http://10.212.232.139:3000/project/155/interface/api/8495) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/next_step`
 * @更新时间 `2023-06-21 14:48:07`
 */
type ApiNextStepPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/next_step',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [下一步↗](http://10.212.232.139:3000/project/155/interface/api/8495) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/next_step`
 * @更新时间 `2023-06-21 14:48:07`
 */
const apiNextStepPostRequestConfig: ApiNextStepPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/next_step',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: false,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiNextStepPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [下一步↗](http://10.212.232.139:3000/project/155/interface/api/8495) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/next_step`
 * @更新时间 `2023-06-21 14:48:07`
 */
export const apiNextStepPost = /*#__PURE__*/ (
	requestData: ApiNextStepPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiNextStepPostResponse>(
		prepare(apiNextStepPostRequestConfig, requestData),
		...args
	);
};

apiNextStepPost.requestConfig = apiNextStepPostRequestConfig;

/**
 * 接口 [IDP初始化接口↗](http://10.212.232.139:3000/project/155/interface/api/8501) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/init`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiInitPostRequest {
	/**
	 * 当前处理类型，为空时默认设置值=1  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
	 */
	from?: number;
	/**
	 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
	 */
	setType?: number;
	/**
	 * 应用id，from=3时需要传第三方应用id
	 */
	clientId?: string;
	/**
	 * 用户登录账号，若存在则以该账号登录，若不存在，则需要用户输入账号
	 */
	username?: string;
	/**
	 * 用户Oscar Verify解绑时，要解绑的设备id
	 */
	unbindOscarVerifyDeviceId?: string;
	/**
	 * 用户Oscar Verify解绑时，要解绑的设备类型
	 */
	unbindOscarVerifyDeviceType?: number;
	/**
	 * 用户Oscar Verify绑定时，要绑定的设备id
	 */
	bindOscarVerifyDeviceId?: string;
	/**
	 * 用户Oscar Verify绑定时，要绑定的设备类型
	 */
	bindOscarVerifyDeviceType?: number;
	/**
	 * sso流程成功后重定向url，若没有设置，流程成功后，根据from返回默认值
	 */
	redirectUrl?: string;
	/**
	 * 当第三方应用登录时，若使用的SAML协议，其相关的信息使用本字段存储
	 */
	samlInfo?: string;
	/**
	 * 免登录时的加密信息，存储了用户相关信息及需要登录的应用
	 */
	signature?: string;
	nonce?: string;
	timestamp?: number;
	encrypt?: string;
	/**
	 * 链接中的对应token
	 */
	linkToken?: string;
}

/**
 * 接口 [IDP初始化接口↗](http://10.212.232.139:3000/project/155/interface/api/8501) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/init`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiInitPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
	/**
	 * 设备id
	 */
	deviceId?: string;
}

/**
 * 接口 [IDP初始化接口↗](http://10.212.232.139:3000/project/155/interface/api/8501) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/init`
 * @更新时间 `2023-06-21 14:48:08`
 */
type ApiInitPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/init',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [IDP初始化接口↗](http://10.212.232.139:3000/project/155/interface/api/8501) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/init`
 * @更新时间 `2023-06-21 14:48:08`
 */
const apiInitPostRequestConfig: ApiInitPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/init',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: false,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiInitPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [IDP初始化接口↗](http://10.212.232.139:3000/project/155/interface/api/8501) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/init`
 * @更新时间 `2023-06-21 14:48:08`
 */
export const apiInitPost = /*#__PURE__*/ (
	requestData: ApiInitPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiInitPostResponse>(prepare(apiInitPostRequestConfig, requestData), ...args);
};

apiInitPost.requestConfig = apiInitPostRequestConfig;

/**
 * 接口 [取消登录，返回登录首页↗](http://10.212.232.139:3000/project/155/interface/api/8507) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_login`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiBackToLoginPostRequest {}

/**
 * 接口 [取消登录，返回登录首页↗](http://10.212.232.139:3000/project/155/interface/api/8507) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_login`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiBackToLoginPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [取消登录，返回登录首页↗](http://10.212.232.139:3000/project/155/interface/api/8507) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_login`
 * @更新时间 `2023-06-21 14:48:08`
 */
type ApiBackToLoginPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/back_to_login',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [取消登录，返回登录首页↗](http://10.212.232.139:3000/project/155/interface/api/8507) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_login`
 * @更新时间 `2023-06-21 14:48:08`
 */
const apiBackToLoginPostRequestConfig: ApiBackToLoginPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/back_to_login',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: true,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiBackToLoginPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [取消登录，返回登录首页↗](http://10.212.232.139:3000/project/155/interface/api/8507) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_login`
 * @更新时间 `2023-06-21 14:48:08`
 */
export const apiBackToLoginPost = /*#__PURE__*/ (
	requestData?: ApiBackToLoginPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiBackToLoginPostResponse>(
		prepare(apiBackToLoginPostRequestConfig, requestData),
		...args
	);
};

apiBackToLoginPost.requestConfig = apiBackToLoginPostRequestConfig;

/**
 * 接口 [身份认证器发送↗](http://10.212.232.139:3000/project/155/interface/api/8513) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/send`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAuthenticatorSendPostRequest {
	/**
	 * 当前处理类型，合法值为（7，12，13，21，104，107，52）  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
	 */
	handlerType?: number;
	/**
	 * 用户要设置的手机号，当type=12时生效
	 */
	phone?: string;
	/**
	 * 用户要设置的邮箱，当type=21时生效
	 */
	email?: string;
}

/**
 * 接口 [身份认证器发送↗](http://10.212.232.139:3000/project/155/interface/api/8513) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/send`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAuthenticatorSendPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [身份认证器发送↗](http://10.212.232.139:3000/project/155/interface/api/8513) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/send`
 * @更新时间 `2023-06-21 14:48:08`
 */
type ApiAuthenticatorSendPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/authenticator/send',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [身份认证器发送↗](http://10.212.232.139:3000/project/155/interface/api/8513) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/send`
 * @更新时间 `2023-06-21 14:48:08`
 */
const apiAuthenticatorSendPostRequestConfig: ApiAuthenticatorSendPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/authenticator/send',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: false,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiAuthenticatorSendPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [身份认证器发送↗](http://10.212.232.139:3000/project/155/interface/api/8513) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/send`
 * @更新时间 `2023-06-21 14:48:08`
 */
export const apiAuthenticatorSendPost = /*#__PURE__*/ (
	requestData: ApiAuthenticatorSendPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiAuthenticatorSendPostResponse>(
		prepare(apiAuthenticatorSendPostRequestConfig, requestData),
		...args
	);
};

apiAuthenticatorSendPost.requestConfig = apiAuthenticatorSendPostRequestConfig;

/**
 * 接口 [身份认证器选择设置列表↗](http://10.212.232.139:3000/project/155/interface/api/8519) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select_set_list`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAuthenticatorSelectSetListPostRequest {}

/**
 * 接口 [身份认证器选择设置列表↗](http://10.212.232.139:3000/project/155/interface/api/8519) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select_set_list`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAuthenticatorSelectSetListPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [身份认证器选择设置列表↗](http://10.212.232.139:3000/project/155/interface/api/8519) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select_set_list`
 * @更新时间 `2023-06-21 14:48:08`
 */
type ApiAuthenticatorSelectSetListPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/authenticator/select_set_list',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [身份认证器选择设置列表↗](http://10.212.232.139:3000/project/155/interface/api/8519) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select_set_list`
 * @更新时间 `2023-06-21 14:48:08`
 */
const apiAuthenticatorSelectSetListPostRequestConfig: ApiAuthenticatorSelectSetListPostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/authenticator/select_set_list',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: true,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiAuthenticatorSelectSetListPost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [身份认证器选择设置列表↗](http://10.212.232.139:3000/project/155/interface/api/8519) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select_set_list`
 * @更新时间 `2023-06-21 14:48:08`
 */
export const apiAuthenticatorSelectSetListPost = /*#__PURE__*/ (
	requestData?: ApiAuthenticatorSelectSetListPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiAuthenticatorSelectSetListPostResponse>(
		prepare(apiAuthenticatorSelectSetListPostRequestConfig, requestData),
		...args
	);
};

apiAuthenticatorSelectSetListPost.requestConfig = apiAuthenticatorSelectSetListPostRequestConfig;

/**
 * 接口 [身份认证器选择校验列表↗](http://10.212.232.139:3000/project/155/interface/api/8525) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select_confirm_list`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAuthenticatorSelectConfirmListPostRequest {}

/**
 * 接口 [身份认证器选择校验列表↗](http://10.212.232.139:3000/project/155/interface/api/8525) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select_confirm_list`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAuthenticatorSelectConfirmListPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [身份认证器选择校验列表↗](http://10.212.232.139:3000/project/155/interface/api/8525) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select_confirm_list`
 * @更新时间 `2023-06-21 14:48:08`
 */
type ApiAuthenticatorSelectConfirmListPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/authenticator/select_confirm_list',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [身份认证器选择校验列表↗](http://10.212.232.139:3000/project/155/interface/api/8525) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select_confirm_list`
 * @更新时间 `2023-06-21 14:48:08`
 */
const apiAuthenticatorSelectConfirmListPostRequestConfig: ApiAuthenticatorSelectConfirmListPostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/authenticator/select_confirm_list',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: true,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiAuthenticatorSelectConfirmListPost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [身份认证器选择校验列表↗](http://10.212.232.139:3000/project/155/interface/api/8525) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select_confirm_list`
 * @更新时间 `2023-06-21 14:48:08`
 */
export const apiAuthenticatorSelectConfirmListPost = /*#__PURE__*/ (
	requestData?: ApiAuthenticatorSelectConfirmListPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiAuthenticatorSelectConfirmListPostResponse>(
		prepare(apiAuthenticatorSelectConfirmListPostRequestConfig, requestData),
		...args
	);
};

apiAuthenticatorSelectConfirmListPost.requestConfig =
	apiAuthenticatorSelectConfirmListPostRequestConfig;

/**
 * 接口 [选择进行确认\/注册的身份认证器↗](http://10.212.232.139:3000/project/155/interface/api/8531) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAuthenticatorSelectPostRequest {
	/**
	 * 选择类型，根据身份认证器选择列表类型是注册还是确认设定当前值，合法值（1，2）  [1-confirm , 2-register ]
	 */
	selectType?: number;
	/**
	 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
	 */
	authenticatorType?: number;
	/**
	 * 认证器方法类型，selectType=1且authenticatorType=4时使用  [1-push , 2-one time password ]
	 */
	authenticatorMethodType?: number;
}

/**
 * 接口 [选择进行确认\/注册的身份认证器↗](http://10.212.232.139:3000/project/155/interface/api/8531) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAuthenticatorSelectPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [选择进行确认\/注册的身份认证器↗](http://10.212.232.139:3000/project/155/interface/api/8531) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select`
 * @更新时间 `2023-06-21 14:48:08`
 */
type ApiAuthenticatorSelectPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/authenticator/select',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [选择进行确认\/注册的身份认证器↗](http://10.212.232.139:3000/project/155/interface/api/8531) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select`
 * @更新时间 `2023-06-21 14:48:08`
 */
const apiAuthenticatorSelectPostRequestConfig: ApiAuthenticatorSelectPostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/authenticator/select',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: false,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiAuthenticatorSelectPost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [选择进行确认\/注册的身份认证器↗](http://10.212.232.139:3000/project/155/interface/api/8531) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/select`
 * @更新时间 `2023-06-21 14:48:08`
 */
export const apiAuthenticatorSelectPost = /*#__PURE__*/ (
	requestData: ApiAuthenticatorSelectPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiAuthenticatorSelectPostResponse>(
		prepare(apiAuthenticatorSelectPostRequestConfig, requestData),
		...args
	);
};

apiAuthenticatorSelectPost.requestConfig = apiAuthenticatorSelectPostRequestConfig;

/**
 * 接口 [身份认证器结果拉取↗](http://10.212.232.139:3000/project/155/interface/api/8537) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/pull`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAuthenticatorPullPostRequest {
	/**
	 * 当前处理类型，合法值为（9，11，19，104，403）  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
	 */
	handlerType?: number;
}

/**
 * 接口 [身份认证器结果拉取↗](http://10.212.232.139:3000/project/155/interface/api/8537) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/pull`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAuthenticatorPullPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [身份认证器结果拉取↗](http://10.212.232.139:3000/project/155/interface/api/8537) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/pull`
 * @更新时间 `2023-06-21 14:48:08`
 */
type ApiAuthenticatorPullPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/authenticator/pull',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [身份认证器结果拉取↗](http://10.212.232.139:3000/project/155/interface/api/8537) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/pull`
 * @更新时间 `2023-06-21 14:48:08`
 */
const apiAuthenticatorPullPostRequestConfig: ApiAuthenticatorPullPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/authenticator/pull',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: false,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiAuthenticatorPullPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [身份认证器结果拉取↗](http://10.212.232.139:3000/project/155/interface/api/8537) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/pull`
 * @更新时间 `2023-06-21 14:48:08`
 */
export const apiAuthenticatorPullPost = /*#__PURE__*/ (
	requestData: ApiAuthenticatorPullPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiAuthenticatorPullPostResponse>(
		prepare(apiAuthenticatorPullPostRequestConfig, requestData),
		...args
	);
};

apiAuthenticatorPullPost.requestConfig = apiAuthenticatorPullPostRequestConfig;

/**
 * 接口 [身份认证器确认↗](http://10.212.232.139:3000/project/155/interface/api/8543) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/confirm`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAuthenticatorConfirmPostRequest {
	/**
	 * 当前处理页面类型，有效值(3,103,105,106,107)  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
	 */
	handlerType?: number;
	/**
	 * 用户输入的凭证，handlerType=103：账号密码handlerType=105：Oscar Verify 的验证码，handlerType=106: 邮箱的验证码handlerType=107: 手机号的验证码handlerType=3: 密码设置的密码handlerType=7: 通过邮箱验证码找回时用的验证码handlerType=13: 设置手机号时的手机验证码handlerType=52: 自主发送激活邮件，通过邮件验证身份的验证码
	 */
	credential?: string;
	/**
	 * 密码加密RS256公钥
	 */
	credentialPublicKey?: string;
}

/**
 * 接口 [身份认证器确认↗](http://10.212.232.139:3000/project/155/interface/api/8543) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/confirm`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAuthenticatorConfirmPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [身份认证器确认↗](http://10.212.232.139:3000/project/155/interface/api/8543) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/confirm`
 * @更新时间 `2023-06-21 14:48:08`
 */
type ApiAuthenticatorConfirmPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/authenticator/confirm',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [身份认证器确认↗](http://10.212.232.139:3000/project/155/interface/api/8543) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/confirm`
 * @更新时间 `2023-06-21 14:48:08`
 */
const apiAuthenticatorConfirmPostRequestConfig: ApiAuthenticatorConfirmPostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/authenticator/confirm',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: false,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiAuthenticatorConfirmPost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [身份认证器确认↗](http://10.212.232.139:3000/project/155/interface/api/8543) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/confirm`
 * @更新时间 `2023-06-21 14:48:08`
 */
export const apiAuthenticatorConfirmPost = /*#__PURE__*/ (
	requestData: ApiAuthenticatorConfirmPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiAuthenticatorConfirmPostResponse>(
		prepare(apiAuthenticatorConfirmPostRequestConfig, requestData),
		...args
	);
};

apiAuthenticatorConfirmPost.requestConfig = apiAuthenticatorConfirmPostRequestConfig;

/**
 * 接口 [用户账号校验↗](http://10.212.232.139:3000/project/155/interface/api/8549) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/account/check`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAccountCheckPostRequest {
	/**
	 * 用户账号
	 */
	username?: string;
}

/**
 * 接口 [用户账号校验↗](http://10.212.232.139:3000/project/155/interface/api/8549) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/account/check`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAccountCheckPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [用户账号校验↗](http://10.212.232.139:3000/project/155/interface/api/8549) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/account/check`
 * @更新时间 `2023-06-21 14:48:08`
 */
type ApiAccountCheckPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/account/check',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [用户账号校验↗](http://10.212.232.139:3000/project/155/interface/api/8549) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/account/check`
 * @更新时间 `2023-06-21 14:48:08`
 */
const apiAccountCheckPostRequestConfig: ApiAccountCheckPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/account/check',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: false,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiAccountCheckPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [用户账号校验↗](http://10.212.232.139:3000/project/155/interface/api/8549) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/account/check`
 * @更新时间 `2023-06-21 14:48:08`
 */
export const apiAccountCheckPost = /*#__PURE__*/ (
	requestData: ApiAccountCheckPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiAccountCheckPostResponse>(
		prepare(apiAccountCheckPostRequestConfig, requestData),
		...args
	);
};

apiAccountCheckPost.requestConfig = apiAccountCheckPostRequestConfig;

/**
 * 接口 [申请解锁↗](http://10.212.232.139:3000/project/155/interface/api/8711) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/apply_for_unlock`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiApplyForUnlockPostRequest {}

/**
 * 接口 [申请解锁↗](http://10.212.232.139:3000/project/155/interface/api/8711) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/apply_for_unlock`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiApplyForUnlockPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [申请解锁↗](http://10.212.232.139:3000/project/155/interface/api/8711) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/apply_for_unlock`
 * @更新时间 `2023-06-21 14:48:08`
 */
type ApiApplyForUnlockPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/apply_for_unlock',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [申请解锁↗](http://10.212.232.139:3000/project/155/interface/api/8711) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/apply_for_unlock`
 * @更新时间 `2023-06-21 14:48:08`
 */
const apiApplyForUnlockPostRequestConfig: ApiApplyForUnlockPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/apply_for_unlock',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: true,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiApplyForUnlockPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [申请解锁↗](http://10.212.232.139:3000/project/155/interface/api/8711) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/apply_for_unlock`
 * @更新时间 `2023-06-21 14:48:08`
 */
export const apiApplyForUnlockPost = /*#__PURE__*/ (
	requestData?: ApiApplyForUnlockPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiApplyForUnlockPostResponse>(
		prepare(apiApplyForUnlockPostRequestConfig, requestData),
		...args
	);
};

apiApplyForUnlockPost.requestConfig = apiApplyForUnlockPostRequestConfig;

/**
 * 接口 [stateToken校验，有效返回成功，无效返回错误码：100101↗](http://10.212.232.139:3000/project/155/interface/api/8837) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/state_token_check`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiStateTokenCheckPostRequest {}

/**
 * 接口 [stateToken校验，有效返回成功，无效返回错误码：100101↗](http://10.212.232.139:3000/project/155/interface/api/8837) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/state_token_check`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiStateTokenCheckPostResponse {}

/**
 * 接口 [stateToken校验，有效返回成功，无效返回错误码：100101↗](http://10.212.232.139:3000/project/155/interface/api/8837) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/state_token_check`
 * @更新时间 `2023-06-21 14:48:06`
 */
type ApiStateTokenCheckPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/state_token_check',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [stateToken校验，有效返回成功，无效返回错误码：100101↗](http://10.212.232.139:3000/project/155/interface/api/8837) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/state_token_check`
 * @更新时间 `2023-06-21 14:48:06`
 */
const apiStateTokenCheckPostRequestConfig: ApiStateTokenCheckPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/state_token_check',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.raw,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: true,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiStateTokenCheckPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [stateToken校验，有效返回成功，无效返回错误码：100101↗](http://10.212.232.139:3000/project/155/interface/api/8837) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/state_token_check`
 * @更新时间 `2023-06-21 14:48:06`
 */
export const apiStateTokenCheckPost = /*#__PURE__*/ (
	requestData?: ApiStateTokenCheckPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiStateTokenCheckPostResponse>(
		prepare(apiStateTokenCheckPostRequestConfig, requestData),
		...args
	);
};

apiStateTokenCheckPost.requestConfig = apiStateTokenCheckPostRequestConfig;

/**
 * 接口 [返回工作台↗](http://10.212.232.139:3000/project/155/interface/api/17861) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_dashboard`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiBackToDashboardPostRequest {}

/**
 * 接口 [返回工作台↗](http://10.212.232.139:3000/project/155/interface/api/17861) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_dashboard`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiBackToDashboardPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [返回工作台↗](http://10.212.232.139:3000/project/155/interface/api/17861) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_dashboard`
 * @更新时间 `2023-06-21 14:48:08`
 */
type ApiBackToDashboardPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/back_to_dashboard',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [返回工作台↗](http://10.212.232.139:3000/project/155/interface/api/17861) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_dashboard`
 * @更新时间 `2023-06-21 14:48:08`
 */
const apiBackToDashboardPostRequestConfig: ApiBackToDashboardPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/back_to_dashboard',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: true,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiBackToDashboardPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [返回工作台↗](http://10.212.232.139:3000/project/155/interface/api/17861) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_dashboard`
 * @更新时间 `2023-06-21 14:48:08`
 */
export const apiBackToDashboardPost = /*#__PURE__*/ (
	requestData?: ApiBackToDashboardPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiBackToDashboardPostResponse>(
		prepare(apiBackToDashboardPostRequestConfig, requestData),
		...args
	);
};

apiBackToDashboardPost.requestConfig = apiBackToDashboardPostRequestConfig;

/**
 * 接口 [安全手机删除↗](http://10.212.232.139:3000/project/155/interface/api/17981) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/security_phone/unbind`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiSecurityPhoneUnbindPostRequest {}

/**
 * 接口 [安全手机删除↗](http://10.212.232.139:3000/project/155/interface/api/17981) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/security_phone/unbind`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiSecurityPhoneUnbindPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [安全手机删除↗](http://10.212.232.139:3000/project/155/interface/api/17981) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/security_phone/unbind`
 * @更新时间 `2023-06-21 14:48:06`
 */
type ApiSecurityPhoneUnbindPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/security_phone/unbind',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [安全手机删除↗](http://10.212.232.139:3000/project/155/interface/api/17981) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/security_phone/unbind`
 * @更新时间 `2023-06-21 14:48:06`
 */
const apiSecurityPhoneUnbindPostRequestConfig: ApiSecurityPhoneUnbindPostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/security_phone/unbind',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: true,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiSecurityPhoneUnbindPost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [安全手机删除↗](http://10.212.232.139:3000/project/155/interface/api/17981) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/security_phone/unbind`
 * @更新时间 `2023-06-21 14:48:06`
 */
export const apiSecurityPhoneUnbindPost = /*#__PURE__*/ (
	requestData?: ApiSecurityPhoneUnbindPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiSecurityPhoneUnbindPostResponse>(
		prepare(apiSecurityPhoneUnbindPostRequestConfig, requestData),
		...args
	);
};

apiSecurityPhoneUnbindPost.requestConfig = apiSecurityPhoneUnbindPostRequestConfig;

/**
 * 接口 [距离下一次可发送的剩余时间↗](http://10.212.232.139:3000/project/155/interface/api/19808) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/remain_time_to_next_send`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiRemainTimeToNextSendPostRequest {
	/**
	 * 当前处理类型，合法值为（7，11，13，19，107，106，111，52）  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
	 */
	handlerType?: number;
	/**
	 * 发送目标，邮箱或手机号，type=11时生效
	 */
	target?: string;
}

/**
 * 接口 [距离下一次可发送的剩余时间↗](http://10.212.232.139:3000/project/155/interface/api/19808) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/remain_time_to_next_send`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiRemainTimeToNextSendPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [距离下一次可发送的剩余时间↗](http://10.212.232.139:3000/project/155/interface/api/19808) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/remain_time_to_next_send`
 * @更新时间 `2023-06-21 14:48:06`
 */
type ApiRemainTimeToNextSendPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/remain_time_to_next_send',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [距离下一次可发送的剩余时间↗](http://10.212.232.139:3000/project/155/interface/api/19808) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/remain_time_to_next_send`
 * @更新时间 `2023-06-21 14:48:06`
 */
const apiRemainTimeToNextSendPostRequestConfig: ApiRemainTimeToNextSendPostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/remain_time_to_next_send',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: false,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiRemainTimeToNextSendPost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [距离下一次可发送的剩余时间↗](http://10.212.232.139:3000/project/155/interface/api/19808) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/remain_time_to_next_send`
 * @更新时间 `2023-06-21 14:48:06`
 */
export const apiRemainTimeToNextSendPost = /*#__PURE__*/ (
	requestData: ApiRemainTimeToNextSendPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiRemainTimeToNextSendPostResponse>(
		prepare(apiRemainTimeToNextSendPostRequestConfig, requestData),
		...args
	);
};

apiRemainTimeToNextSendPost.requestConfig = apiRemainTimeToNextSendPostRequestConfig;

/**
 * 接口 [返回密码认证页面↗](http://10.212.232.139:3000/project/155/interface/api/20612) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_password`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiBackToPasswordPostRequest {}

/**
 * 接口 [返回密码认证页面↗](http://10.212.232.139:3000/project/155/interface/api/20612) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_password`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiBackToPasswordPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [返回密码认证页面↗](http://10.212.232.139:3000/project/155/interface/api/20612) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_password`
 * @更新时间 `2023-06-21 14:48:08`
 */
type ApiBackToPasswordPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/back_to_password',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [返回密码认证页面↗](http://10.212.232.139:3000/project/155/interface/api/20612) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_password`
 * @更新时间 `2023-06-21 14:48:08`
 */
const apiBackToPasswordPostRequestConfig: ApiBackToPasswordPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/back_to_password',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: true,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiBackToPasswordPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [返回密码认证页面↗](http://10.212.232.139:3000/project/155/interface/api/20612) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_password`
 * @更新时间 `2023-06-21 14:48:08`
 */
export const apiBackToPasswordPost = /*#__PURE__*/ (
	requestData?: ApiBackToPasswordPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiBackToPasswordPostResponse>(
		prepare(apiBackToPasswordPostRequestConfig, requestData),
		...args
	);
};

apiBackToPasswordPost.requestConfig = apiBackToPasswordPostRequestConfig;

/**
 * 接口 [openId登录检查↗](http://10.212.232.139:3000/project/155/interface/api/22214) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/openid_login_check`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiOpenidLoginCheckPostRequest {
	/**
	 * oidc协议返回的code
	 */
	code?: string;
	/**
	 * oidc协议返回的state
	 */
	state?: string;
	/**
	 * 认证请求的原始应用id
	 */
	orgClientId?: string;
}

/**
 * 接口 [openId登录检查↗](http://10.212.232.139:3000/project/155/interface/api/22214) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/openid_login_check`
 * @更新时间 `2023-06-21 14:48:07`
 */
export interface ApiOpenidLoginCheckPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [openId登录检查↗](http://10.212.232.139:3000/project/155/interface/api/22214) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/openid_login_check`
 * @更新时间 `2023-06-21 14:48:07`
 */
type ApiOpenidLoginCheckPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/openid_login_check',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [openId登录检查↗](http://10.212.232.139:3000/project/155/interface/api/22214) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/openid_login_check`
 * @更新时间 `2023-06-21 14:48:07`
 */
const apiOpenidLoginCheckPostRequestConfig: ApiOpenidLoginCheckPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/openid_login_check',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: false,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiOpenidLoginCheckPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [openId登录检查↗](http://10.212.232.139:3000/project/155/interface/api/22214) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/openid_login_check`
 * @更新时间 `2023-06-21 14:48:07`
 */
export const apiOpenidLoginCheckPost = /*#__PURE__*/ (
	requestData: ApiOpenidLoginCheckPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiOpenidLoginCheckPostResponse>(
		prepare(apiOpenidLoginCheckPostRequestConfig, requestData),
		...args
	);
};

apiOpenidLoginCheckPost.requestConfig = apiOpenidLoginCheckPostRequestConfig;

/**
 * 接口 [Oscar登录二次确认↗](http://10.212.232.139:3000/project/155/interface/api/24788) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/secondLoginConfirm`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiSecondLoginConfirmPostRequest {}

/**
 * 接口 [Oscar登录二次确认↗](http://10.212.232.139:3000/project/155/interface/api/24788) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/secondLoginConfirm`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiSecondLoginConfirmPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [Oscar登录二次确认↗](http://10.212.232.139:3000/project/155/interface/api/24788) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/secondLoginConfirm`
 * @更新时间 `2023-06-21 14:48:06`
 */
type ApiSecondLoginConfirmPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/secondLoginConfirm',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [Oscar登录二次确认↗](http://10.212.232.139:3000/project/155/interface/api/24788) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/secondLoginConfirm`
 * @更新时间 `2023-06-21 14:48:06`
 */
const apiSecondLoginConfirmPostRequestConfig: ApiSecondLoginConfirmPostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/secondLoginConfirm',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: true,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiSecondLoginConfirmPost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [Oscar登录二次确认↗](http://10.212.232.139:3000/project/155/interface/api/24788) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/secondLoginConfirm`
 * @更新时间 `2023-06-21 14:48:06`
 */
export const apiSecondLoginConfirmPost = /*#__PURE__*/ (
	requestData?: ApiSecondLoginConfirmPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiSecondLoginConfirmPostResponse>(
		prepare(apiSecondLoginConfirmPostRequestConfig, requestData),
		...args
	);
};

apiSecondLoginConfirmPost.requestConfig = apiSecondLoginConfirmPostRequestConfig;

/**
 * 接口 [自主发送激活邮件流程中，用户账号校验↗](http://10.212.232.139:3000/project/155/interface/api/24830) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/ssae/account/check`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiSsaeAccountCheckPostRequest {
	/**
	 * 用户账号
	 */
	username?: string;
}

/**
 * 接口 [自主发送激活邮件流程中，用户账号校验↗](http://10.212.232.139:3000/project/155/interface/api/24830) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/ssae/account/check`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiSsaeAccountCheckPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [自主发送激活邮件流程中，用户账号校验↗](http://10.212.232.139:3000/project/155/interface/api/24830) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/ssae/account/check`
 * @更新时间 `2023-06-21 14:48:06`
 */
type ApiSsaeAccountCheckPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/ssae/account/check',
		'data',
		string,
		string,
		false
	>
>;

/**
 * 接口 [自主发送激活邮件流程中，用户账号校验↗](http://10.212.232.139:3000/project/155/interface/api/24830) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/ssae/account/check`
 * @更新时间 `2023-06-21 14:48:06`
 */
const apiSsaeAccountCheckPostRequestConfig: ApiSsaeAccountCheckPostRequestConfig = /*#__PURE__*/ {
	mockUrl: mockUrl_0_0_0_0,
	devUrl: devUrl_0_0_0_0,
	prodUrl: prodUrl_0_0_0_0,
	path: '/api/auth/v1/idp/v1/ssae/account/check',
	method: Method.POST,
	requestHeaders: {},
	requestBodyType: RequestBodyType.json,
	responseBodyType: ResponseBodyType.json,
	dataKey: dataKey_0_0_0_0,
	paramNames: [],
	queryNames: [],
	requestDataOptional: false,
	requestDataJsonSchema: {},
	responseDataJsonSchema: {},
	requestFunctionName: 'apiSsaeAccountCheckPost',
	queryStringArrayFormat: QueryStringArrayFormat.brackets,
	extraInfo: {},
};

/**
 * 接口 [自主发送激活邮件流程中，用户账号校验↗](http://10.212.232.139:3000/project/155/interface/api/24830) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/ssae/account/check`
 * @更新时间 `2023-06-21 14:48:06`
 */
export const apiSsaeAccountCheckPost = /*#__PURE__*/ (
	requestData: ApiSsaeAccountCheckPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiSsaeAccountCheckPostResponse>(
		prepare(apiSsaeAccountCheckPostRequestConfig, requestData),
		...args
	);
};

apiSsaeAccountCheckPost.requestConfig = apiSsaeAccountCheckPostRequestConfig;

/**
 * 接口 [返回自主激活流程账号验证页面↗](http://10.212.232.139:3000/project/155/interface/api/25259) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_ssae_account_check`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiBackToSsaeAccountCheckPostRequest {}

/**
 * 接口 [返回自主激活流程账号验证页面↗](http://10.212.232.139:3000/project/155/interface/api/25259) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_ssae_account_check`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiBackToSsaeAccountCheckPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [返回自主激活流程账号验证页面↗](http://10.212.232.139:3000/project/155/interface/api/25259) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_ssae_account_check`
 * @更新时间 `2023-06-21 14:48:08`
 */
type ApiBackToSsaeAccountCheckPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/back_to_ssae_account_check',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [返回自主激活流程账号验证页面↗](http://10.212.232.139:3000/project/155/interface/api/25259) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_ssae_account_check`
 * @更新时间 `2023-06-21 14:48:08`
 */
const apiBackToSsaeAccountCheckPostRequestConfig: ApiBackToSsaeAccountCheckPostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/back_to_ssae_account_check',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: true,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiBackToSsaeAccountCheckPost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [返回自主激活流程账号验证页面↗](http://10.212.232.139:3000/project/155/interface/api/25259) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/back_to_ssae_account_check`
 * @更新时间 `2023-06-21 14:48:08`
 */
export const apiBackToSsaeAccountCheckPost = /*#__PURE__*/ (
	requestData?: ApiBackToSsaeAccountCheckPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiBackToSsaeAccountCheckPostResponse>(
		prepare(apiBackToSsaeAccountCheckPostRequestConfig, requestData),
		...args
	);
};

apiBackToSsaeAccountCheckPost.requestConfig = apiBackToSsaeAccountCheckPostRequestConfig;

/**
 * 接口 [安全邮箱删除↗](http://10.212.232.139:3000/project/155/interface/api/37382) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/security_email/unbind`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiSecurityEmailUnbindPostRequest {}

/**
 * 接口 [安全邮箱删除↗](http://10.212.232.139:3000/project/155/interface/api/37382) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/security_email/unbind`
 * @更新时间 `2023-06-21 14:48:06`
 */
export interface ApiSecurityEmailUnbindPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [安全邮箱删除↗](http://10.212.232.139:3000/project/155/interface/api/37382) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/security_email/unbind`
 * @更新时间 `2023-06-21 14:48:06`
 */
type ApiSecurityEmailUnbindPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/security_email/unbind',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [安全邮箱删除↗](http://10.212.232.139:3000/project/155/interface/api/37382) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/security_email/unbind`
 * @更新时间 `2023-06-21 14:48:06`
 */
const apiSecurityEmailUnbindPostRequestConfig: ApiSecurityEmailUnbindPostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/security_email/unbind',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: true,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiSecurityEmailUnbindPost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [安全邮箱删除↗](http://10.212.232.139:3000/project/155/interface/api/37382) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/security_email/unbind`
 * @更新时间 `2023-06-21 14:48:06`
 */
export const apiSecurityEmailUnbindPost = /*#__PURE__*/ (
	requestData?: ApiSecurityEmailUnbindPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiSecurityEmailUnbindPostResponse>(
		prepare(apiSecurityEmailUnbindPostRequestConfig, requestData),
		...args
	);
};

apiSecurityEmailUnbindPost.requestConfig = apiSecurityEmailUnbindPostRequestConfig;

/**
 * 接口 [跳转手动输入邮箱验证码页面↗](http://10.212.232.139:3000/project/155/interface/api/38174) 的 **请求类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/switch_to_email_otp`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAuthenticatorSwitchToEmailOtpPostRequest {}

/**
 * 接口 [跳转手动输入邮箱验证码页面↗](http://10.212.232.139:3000/project/155/interface/api/38174) 的 **返回类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/switch_to_email_otp`
 * @更新时间 `2023-06-21 14:48:08`
 */
export interface ApiAuthenticatorSwitchToEmailOtpPostResponse {
	/**
	 * oscar用户名称
	 */
	oscarUserName?: string;
	/**
	 * token值及过期时间
	 */
	stateToken?: {
		/**
		 * token值
		 */
		value?: string;
		/**
		 * token过期时间戳，单位毫秒
		 */
		expireAt?: number;
	};
	/**
	 * 处理数据信息
	 */
	next?: {
		/**
		 * 处理页面类型，type=1 时有效  [1-TenantSet , 2-AccountCheck , 3-PasswordSet , 4-ActiveSuccess , 5-ResetSuccess , 6-RecoverPasswordWithLink , 7-RecoverPasswordWithCode , 8-OscarVerifyBindLinkTransfer , 9-OscarVerifyBindQrcode , 10-OscarVerifyBindLink , 11-OscarVerifyBindLinkWait , 12-PhoneSet , 13-PhoneSetOtpVerify , 14-OscarVerifyUnbind , 15-RecoverPasswordCancel , 16-RecoverPasswordModifiedByOther , 17-RedirectToBindOscarVerifyInAppAfterLogin , 18-PhoneDelete , 19-OscarVerifyBindLinkWaitWithPhone , 20-secondConfirmWithCurrentAccount , 21-EmailSet , 22-EmailSetOtpVerify , 23-EmailDelete , 51-SSAEAccountCheck , 52-SSAEVerifyValidationEmail , 53-SSAESendActivationEmailTooMuch , 54-SSAESendActivationEmailSuccess , 55-SSAEAccountUnableToActive , 56-SSAESelfActivationNotOpen , 57-SendEmailAuthenticatorSmsTooMuch , 58-SendPhoneAuthenticatorBindTooMuch , 59-SendEmailAuthenticatorSmsTooMuch , 60-SendPhoneAuthenticatorBindTooMuch , 101-AuthenticatorSelectConfirmList , 102-AuthenticatorSelectSetList , 103-AuthenticatorPassword , 104-AuthenticatorOscarVerifyPush , 105-AuthenticatorOscarVerifyOTP , 106-AuthenticatorEmail , 107-AuthenticatorPhone , 108-OtherAuthenticatorSelectSetList , 109-AuthenticatorPasswordTemp , 110-PreAuthenticatorEmail , 111-AuthenticatorEmailWaiting , 112-AuthenticatorEmailOtp , 401-LinkRot , 402-AccountFailure , 403-AccountLocked , 404-SessionTimeout , 405-AccountUnLocked , 406-ActiveLinkRot , 407-ResetPasswordLinkRot , 408-RecoverPasswordLinkRot , 409-OscarVerifyBindActiveLinkRot , 410-CanNotRecoverPassword , 411-UnknownError , 412-EmailAuthenticatorLinkRot , 901-RedirectTo , 999-DoNothing ]
		 */
		type?: number;
		/**
		 * 奥斯卡认证设备绑定信息
		 */
		bindInfo?: {
			qrcode?: string;
		};
		/**
		 * 需要要用户进行验证使用的身份验证器选择，type=101 时生效
		 */
		authenticatorSelectConfirmList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 需要要用户进行设置使用的身份验证器选择，type in (102,108) 时生效
		 */
		authenticatorSelectSetList?: {
			id?: string;
			/**
			 * 认证器类型  [1-Password , 2-Email , 3-Phone , 4-Oscar Verify , 5-OpenID ]
			 */
			type?: number;
			/**
			 * 身份认证器名称
			 */
			name?: string;
			/**
			 * 一种身份认证器会拥有多种认证方式
			 */
			methods?: {
				id?: string;
				/**
				 * 认证器方法类型  [1-push , 2-one time password ]
				 */
				type?: number;
			}[];
		}[];
		/**
		 * 用户设置的身份验证器选择是否可以后设置效
		 */
		authenticatorSelectSetListSetLater?: boolean;
		/**
		 * 解锁时间，单位毫秒,type=403时生效
		 */
		unlockAt?: number;
		/**
		 * 是否已申请解锁,type=403时生效
		 */
		applyForUnlock?: boolean;
		/**
		 * 要展示的手机号，type in（13，107）时生效
		 */
		displayPhone?: string;
		/**
		 * 要展示的邮箱列表，type in（7，106）时生效
		 */
		displayEmails?: string[];
		/**
		 * 要展示的otp，type in (112) 时生效
		 */
		displayOtp?: string;
		/**
		 * 邮件或者短信再次发送的剩余时间，单位毫秒，type in（7，11，13，106，107）时生效
		 */
		remainTime?: number;
		/**
		 * 身份认证器认证时是否默认使用oscar verify +push方式的用户选择；0：不选择，1：选择
		 */
		oscarVerifyAutoSendPushOption?: number;
		/**
		 * 父流程用户代理端名称，在浏览器端访问则是浏览器名称，type in（6）时生效
		 */
		parentAgentName?: string;
		/**
		 * 父流程来源名称，type in（6）时生效
		 */
		parentFromName?: string;
		/**
		 * 重定向地址，type in（901）时生效
		 */
		redirectUrl?: string;
		/**
		 * openid入口跳转URL， 如果有值，则表示需要跳转
		 */
		openIDEntryUrl?: string;
		/**
		 * 账号激活入口显示，1=显示，0=不显示
		 */
		activeEntryShow?: boolean;
		/**
		 * 应用logo地址
		 */
		appLogoUrl?: string;
		/**
		 * 密码加密的RS256公钥
		 */
		credentialPublicKey?: string;
		/**
		 * 发送激活邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（53）时生效
		 */
		activationEmailSendLimitTime?: number;
		/**
		 * 发送绑定验证因素邮件限制时间，当前时间超过限制时间才能发送激活邮件，type in（57）时生效
		 */
		emailAuthenticatorSmsSendLimitTime?: number;
		/**
		 * 发送绑定验证因素手机号限制时间，当前时间超过限制时间才能发送短信验证码，type in（58）时生效
		 */
		phoneAuthenticatorSmsSendLimitTime?: number;
	};
	/**
	 * 登录，激活，设置等流程处理成功后数据
	 */
	success?: {
		/**
		 * 成功跳转地址
		 */
		redirectUrl?: string;
		/**
		 * token值及过期时间
		 */
		oscarToken?: {
			/**
			 * token值
			 */
			value?: string;
			/**
			 * token过期时间戳，单位毫秒
			 */
			expireAt?: number;
		};
		/**
		 * saml信息
		 */
		saml?: string;
	};
	/**
	 * SSO流程来源
	 */
	fromInfo?: {
		/**
		 * 流程来源类型  [1-Dashboard , 2-Admin , 3-ThirdPartApp , 4-Active , 5-Set , 6-RecoverPassword , 7-ResetPassword , 8-OscarVerifyBind , 9-OscarVerifyBindByLogin , 10-SelfSendActivationEmail , 11-EmailAuthenticatorLinkLogin ]
		 */
		from?: number;
		/**
		 * 设置的详细类型，from=5时使用  [1-password , 2-phone , 3-oscar verify bind , 4-oscar verify unbind , 5-phone delete , 6-free login , 7-email , 8-email delete ]
		 */
		setType?: number;
		/**
		 * 发起登录请求的客户端ID
		 */
		clientId?: string;
	};
}

/**
 * 接口 [跳转手动输入邮箱验证码页面↗](http://10.212.232.139:3000/project/155/interface/api/38174) 的 **请求配置的类型**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/switch_to_email_otp`
 * @更新时间 `2023-06-21 14:48:08`
 */
type ApiAuthenticatorSwitchToEmailOtpPostRequestConfig = Readonly<
	RequestConfig<
		'http://10.212.232.139:3000/mock/155',
		'',
		'',
		'/api/auth/v1/idp/v1/authenticator/switch_to_email_otp',
		'data',
		string,
		string,
		true
	>
>;

/**
 * 接口 [跳转手动输入邮箱验证码页面↗](http://10.212.232.139:3000/project/155/interface/api/38174) 的 **请求配置**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/switch_to_email_otp`
 * @更新时间 `2023-06-21 14:48:08`
 */
const apiAuthenticatorSwitchToEmailOtpPostRequestConfig: ApiAuthenticatorSwitchToEmailOtpPostRequestConfig =
	/*#__PURE__*/ {
		mockUrl: mockUrl_0_0_0_0,
		devUrl: devUrl_0_0_0_0,
		prodUrl: prodUrl_0_0_0_0,
		path: '/api/auth/v1/idp/v1/authenticator/switch_to_email_otp',
		method: Method.POST,
		requestHeaders: {},
		requestBodyType: RequestBodyType.json,
		responseBodyType: ResponseBodyType.json,
		dataKey: dataKey_0_0_0_0,
		paramNames: [],
		queryNames: [],
		requestDataOptional: true,
		requestDataJsonSchema: {},
		responseDataJsonSchema: {},
		requestFunctionName: 'apiAuthenticatorSwitchToEmailOtpPost',
		queryStringArrayFormat: QueryStringArrayFormat.brackets,
		extraInfo: {},
	};

/**
 * 接口 [跳转手动输入邮箱验证码页面↗](http://10.212.232.139:3000/project/155/interface/api/38174) 的 **请求函数**
 *
 * @分类 [identity provider相关接口↗](http://10.212.232.139:3000/project/155/interface/api/cat_2585)
 * @标签 `identity provider相关接口`
 * @请求头 `POST /api/auth/v1/idp/v1/authenticator/switch_to_email_otp`
 * @更新时间 `2023-06-21 14:48:08`
 */
export const apiAuthenticatorSwitchToEmailOtpPost = /*#__PURE__*/ (
	requestData?: ApiAuthenticatorSwitchToEmailOtpPostRequest,
	...args: UserRequestRestArgs
) => {
	return request<ApiAuthenticatorSwitchToEmailOtpPostResponse>(
		prepare(apiAuthenticatorSwitchToEmailOtpPostRequestConfig, requestData),
		...args
	);
};

apiAuthenticatorSwitchToEmailOtpPost.requestConfig =
	apiAuthenticatorSwitchToEmailOtpPostRequestConfig;

/* prettier-ignore-end */
